import React, { useState, useEffect, useReducer } from 'react'
import { useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import { makeStyles } from '@material-ui/core/styles'
import Avatar from '@material-ui/core/Avatar'
import Backdrop from '@material-ui/core/Backdrop'
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import CircularProgress from '@material-ui/core/CircularProgress'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import Grid from '@material-ui/core/Grid'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import TablePagination from '@material-ui/core/TablePagination'
import TextField from '@material-ui/core/TextField'
import SearchIcon from '@material-ui/icons/Search'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'

import { get, post } from '../../config/fetch'
import AlertWrapper from '../common/alert'
import { TOKEN_CREATE_DEVICE_LIST, TOKEN_GET_DEVICES, TOKEN_GET_DEVICES_LIST } from '../../constants/constants'

const columns = [
    { id: 'brand', disablePadding: false, label: 'Brand' },
    { id: 'model', disablePadding: false, label: 'Model' },
    { id: 'deviceId', disablePadding: false, label: 'Device ID' },
    { id: 'msisdn', disablePadding: false, label: 'MSISDN' },
]

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1
    }
    if (b[orderBy] > a[orderBy]) {
        return 1
    }
    return 0
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0])
        if (order !== 0) return order
        return a[1] - b[1]
    })
    return stabilizedThis.map(el => el[0])
}

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    listItem: {
        backgroundColor: theme.palette.background.paper,
        margin: '.5em 0',
    },
    table: {
        width: '98%',
        margin: '1em auto',
    },
    rootList: {
        width: '95%',

        margin: '1em 0',
    },
}))

function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props
    const createSortHandler = property => event => {
        onRequestSort(event, property)
    }

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{ 'aria-label': 'select all desserts' }}
                    />
                </TableCell>
                {columns.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

function DialogList(props) {
    const {
        classes,
        control,
        handleCloseDialogReport,
        handleSubmit,
        loadingReport,
        saveDevicesList,
        visibleDialogReport,
    } = props
    return (
        <Dialog
            open={visibleDialogReport}
            onClose={handleCloseDialogReport}
            aria-labelledby="form-dialog-devices-list-title"
        >
            <DialogTitle id="form-dialog-devices-list-title">New Custom list</DialogTitle>
            <DialogContent>
                <DialogContentText>Please enter the devices list name here.</DialogContentText>
                {loadingReport ? (
                    <div className={classes.wrapperLoader}>
                        <CircularProgress />
                    </div>
                ) : (
                    <form onSubmit={handleSubmit(saveDevicesList)}>
                        <Controller
                            name="name"
                            control={control}
                            rules={{ required: true }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    autoFocus
                                    margin="dense"
                                    label="Name"
                                    type="text"
                                    fullWidth
                                    required
                                    inputRef={field.ref}
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                    </form>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialogReport} color="primary" disabled={loadingReport}>
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit(saveDevicesList)}
                    color="primary"
                    type="submit"
                    disabled={loadingReport}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    )
}

function Devices() {
    const classes = useStyles()
    const history = useHistory()
    const { handleSubmit, control, reset } = useForm()
    const [state, setState] = useReducer((s, a) => ({ ...s, ...a }), {
        error: null,
        loading: true,
        resolved: false,
        devicesList: [],
        devices: [],
    })
    const [stateCustomList, setStateCustomList] = useReducer((s, a) => ({ ...s, ...a }), {
        error: null,
        loading: false,
        message: null,
        resolved: false,
        typeMessage: null,
        visibleMessage: false,
    })
    const [stateSearch, setStateSearch] = useReducer((s, a) => ({ ...s, ...a }), {
        input: '',
        loading: false,
    })
    const [order, setOrder] = useState('asc')
    const [orderBy, setOrderBy] = useState('calories')
    const [selected, setSelected] = useState([])
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [visibleDialogReport, setVisibleDialogReport] = useState(false)

    useEffect(() => {
        fetchInit()
    }, [])

    const fetchInit = () => {
        Promise.all([fetchDevicesList(), fetchDevices()])
            .then(values => {
                setState({
                    ...state,
                    loading: false,
                    resolved: true,
                    devicesList: values[0],
                    devices: values[1],
                })
            })
            .catch(e => {
                setState({
                    ...state,
                    loading: false,
                    error: e,
                })
            })
    }

    const fetchDevicesList = async () => {
        try {
            const { data: devicesList } = await get(
                `/devicesList?code=${TOKEN_GET_DEVICES_LIST}`,
            )

            return devicesList
        } catch (e) {
            throw new Error(e)
        }
    }

    const fetchDevices = async (search = '') => {
        try {
            const { data: devices } = await get(
                `/devices?code=${TOKEN_GET_DEVICES}&search=${search}`,
            )

            return devices
        } catch (e) {
            throw new Error(e)
        }
    }

    const filterDevices = text => {
        setStateSearch({
            ...state,
            loading: true,
        })
        fetchDevices(text)
            .then(response => {
                setStateSearch({
                    ...state,
                    loading: false,
                })
                setState({
                    ...state,
                    loading: false,
                    resolved: true,
                    devices: response,
                })
            })
            .catch(e => {
                setState({
                    ...state,
                    loading: false,
                    error: e,
                })
            })
    }

    const handleClickCustomList = (e, report) => {
        history.push(`/devicesList/${report.id}`)
    }

    const handleCloseDialogReport = () => {
        setVisibleDialogReport(false)
        reset()
    }

    const handleCloseMessageReport = () => {
        setStateCustomList({
            ...stateCustomList,
            visibleMessage: false,
        })
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc'
        setOrder(isAsc ? 'desc' : 'asc')
        setOrderBy(property)
    }

    const handleSelectAllClick = event => {
        if (event.target.checked) {
            const newSelecteds = state.devices.map(n => n.name)
            setSelected(newSelecteds)
            return
        }
        setSelected([])
    }

    const handleClickRow = (event, name) => {
        const selectedIndex = selected.indexOf(name)
        let newSelected = []

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name)
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1))
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1))
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            )
        }

        setSelected(newSelected)
    }

    const handleClickCreateList = () => {
        // open dialog to fill list name
        setVisibleDialogReport(true)
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    const saveDevicesList = async data => {
        const newCustomList = {
            ...data,
            devices: selected,
        }

        setStateCustomList({
            ...stateCustomList,
            loading: true,
        })
        try {
            const { data } = await post(
                '/devicesList?code=' + TOKEN_CREATE_DEVICE_LIST,
                newCustomList,
            )
            setStateCustomList({
                ...stateCustomList,
                loading: false,
                resolved: true,
                visibleMessage: true,
                typeMessage: 'success',
                message: `Custom list '${data.name}' has been saved successfuly.`,
            })
            setSelected([])
            reset()
            fetchInit()
            setVisibleDialogReport(false)
        } catch (e) {
            setStateCustomList({
                ...stateCustomList,
                loading: false,
                error: e,
                visibleMessage: true,
                typeMessage: 'error',
                message: `An error has ocurred. Please, try again.`,
            })
            setVisibleDialogReport(false)
            throw new Error(e)
        }
    }

    const handleKeyPress = e => {
        if (e.key === 'Enter') {
            filterDevices(stateSearch.input)
        }
    }

    // render variables
    const isSelected = name => selected.indexOf(name) !== -1
    const rows = state.devices
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage)

    // render
    if (!state.resolved)
        return (
            <Backdrop className={classes.backdrop} open={state.loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    return (
        <Grid container spacing={0}>
            <Grid container direction="row" justify="flex-start" alignItems="flex-start">
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={8}
                    xl={8}
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                >
                    <Grid
                        xs={11}
                        sm={11}
                        md={11}
                        lg={11}
                        xl={11}
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                        style={{ borderBottom: '1px solid' }}
                    >
                        <h2>All devices</h2>
                        {selected.length > 0 && (
                            <Button
                                type="button"
                                variant="contained"
                                color="default"
                                className={classes.submit}
                                onClick={handleClickCreateList}
                            >
                                create list
                            </Button>
                        )}
                    </Grid>
                    <Grid
                        xs={11}
                        sm={11}
                        md={11}
                        lg={11}
                        xl={11}
                        container
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                        style={{ marginTop: 10 }}
                    >
                        <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                            <TextField
                                fullWidth
                                size="large"
                                id="standard-basic"
                                label="Search by Brand, Model, Device ID"
                                onChange={e =>
                                    setStateSearch({ ...stateSearch, input: e.target.value })
                                }
                                onKeyDown={handleKeyPress}
                                disabled={stateSearch.loading}
                            />
                        </Grid>

                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                            {stateSearch.loading ? (
                                <CircularProgress color="inherit" />
                            ) : (
                                <IconButton
                                    type="submit"
                                    className={classes.iconButton}
                                    aria-label="search"
                                    onClick={() => filterDevices(stateSearch.input)}
                                >
                                    <SearchIcon />
                                </IconButton>
                            )}
                        </Grid>
                    </Grid>

                    <div style={{ width: '95%' }}>
                        <TableContainer>
                            <Table
                                className={classes.table}
                                aria-labelledby="tableTitle"
                                size={'medium'}
                                aria-label="enhanced table"
                            >
                                <EnhancedTableHead
                                    classes={classes}
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={handleSelectAllClick}
                                    onRequestSort={handleRequestSort}
                                    rowCount={rows.length}
                                />
                                <TableBody>
                                    {stableSort(rows, getComparator(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row, index) => {
                                            const isItemSelected = isSelected(row.id)
                                            const labelId = `enhanced-table-checkbox-${index}`

                                            return (
                                                <TableRow
                                                    hover
                                                    onClick={event => handleClickRow(event, row.id)}
                                                    role="checkbox"
                                                    aria-checked={isItemSelected}
                                                    tabIndex={-1}
                                                    key={row.id}
                                                    selected={isItemSelected}
                                                >
                                                    <TableCell padding="checkbox">
                                                        <Checkbox
                                                            checked={isItemSelected}
                                                            inputProps={{
                                                                'aria-labelledby': labelId,
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>{row.brand}</TableCell>
                                                    <TableCell>{row.model}</TableCell>
                                                    <TableCell align="left">
                                                        {row.deviceId}
                                                    </TableCell>
                                                    <TableCell>{row.msisdn || '-'}</TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    {emptyRows > 0 && (
                                        <TableRow style={{ height: 53 * emptyRows }}>
                                            <TableCell colSpan={6} />
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </div>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={4}
                    xl={4}
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                >
                    <Grid
                        item
                        xs={11}
                        sm={11}
                        md={11}
                        lg={11}
                        xl={11}
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                        style={{ borderBottom: '1px solid' }}
                    >
                        <h2>Custom list</h2>
                    </Grid>
                    <List className={classes.rootList}>
                        {state.devicesList.map(value => {
                            const labelId = `device-list-${value.id}`
                            return (
                                <ListItem
                                    key={value.id}
                                    button
                                    className={classes.listItem}
                                    onClick={e => handleClickCustomList(e, value)}
                                >
                                    <ListItemAvatar>
                                        <Avatar
                                            alt={value.name}
                                            src={`/static/images/avatar/${value + 1}.jpg`}
                                        />
                                    </ListItemAvatar>
                                    <ListItemText
                                        id={labelId}
                                        primary={value.name}
                                        secondary={`${value.devices.length} device${
                                            value.devices.length > 1 ? 's' : ''
                                        }`}
                                    />
                                </ListItem>
                            )
                        })}
                    </List>
                </Grid>
            </Grid>
            <DialogList
                classes={classes}
                control={control}
                handleCloseDialogReport={handleCloseDialogReport}
                handleSubmit={handleSubmit}
                loadingReport={stateCustomList.loading}
                saveDevicesList={saveDevicesList}
                visibleDialogReport={visibleDialogReport}
            />
            <AlertWrapper
                description={stateCustomList.message}
                handleClose={handleCloseMessageReport}
                type={stateCustomList.typeMessage}
                visible={stateCustomList.visibleMessage}
            />
        </Grid>
    )
}

export default Devices
